
import themeMixin from '~/mixins/theme'

export default {
  name: 'Loader',
  mixins: [themeMixin],
  props: {
    error: {
      type: [String, Boolean],
      required: false,
      default: null,
    },
    isLoading: {
      type: Boolean,
      required: true,
      default: true,
    },
    // the minimum amount of time to show the spinner for
    /// before hiding it and showing the dynamic content
    loadingDelay: {
      type: Number,
      required: false,
      default: 300,
    },
  },
  data() {
    return {
      timeoutRef: null,
      isLoadingState: false,
    }
  },
  watch: {
    isLoading(newVal) {
      clearTimeout(this.timeoutRef)
      this.timeoutRef = setTimeout(() => {
        this.isLoadingState = newVal
      }, this.loadingDelay)
    },
  },
  mounted() {
    this.isLoadingState = this.isLoading
  },
  destroyed() {
    clearTimeout(this.timeoutRef)
  },
}
